export default __webpack_public_path__ + "static/media/example_4@2x.50de918c.png";